module.exports = __WEBPACK_EXTERNAL_MODULE_45__;


//////////////////
// WEBPACK FOOTER
// external "element-ui/lib/theme-chalk/dialog.css"
// module id = 45
// module chunks = 0 1